export default __webpack_public_path__ + "static/media/house_five.7f96dd0e.png";